import { useMemo } from 'react';
import { createResourceAtom } from 'lib/atoms';
import type { AfeHeaderDetailResponse } from '../types';

const useAfeDetailAtom = (id: string) =>
  useMemo(
    () => createResourceAtom<AfeHeaderDetailResponse>(`/afe_headers/${id}`),
    [id]
  );

export { useAfeDetailAtom };
